angular.module('dealerware.web.data').factory('DealerwareVehicleModel', function ($rootScope,$http,Model,$q,DealerwareIssueCollection,DealerwareScanCollection,DealerwareVehicleContractCollection,DealerwareTollCollection, $dealerwareInternationalizationDateFormats) {
    var parseDateForRequest = function (date) {
        var parsedDate = $dealerwareInternationalizationDateFormats.parseDateForRequest(date, 'YYYY-MM-DD');
        return parsedDate;
    };

    var parseDateForResponse = function (date) {
        var lastFormats = ['YYYY-MM-DD', 'MM-DD-YYYY'];
        var parsedDate = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(date, lastFormats);
        return date !== null && date !== undefined ? parsedDate : '';
    };


    var model = new Model({
        baseEndpoint: '/locations/:location_id/cars',
        requestTransforms: new function() {
            this.create = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });

                $.extend(data, {
                    car: {
                        available_date: origData.available_date,
                        stock_number: origData.stock_number,
                        license: origData.license,
                        license_state: origData.license_state,
                        trim_id: origData.trim_id,
                        vin: origData.vin,
                        bt_id: origData.vin
                    }
                });

                if (origData.hasOwnProperty('location') && origData.location.hasOwnProperty('data') && angular.isObject(origData.location.data)) {
                    data.location_id = origData.location.data.id;
                }
            };

            this.saveVehicleDetails = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    id: origData.id,
                    location_id: origData.location_id,
                    car: {
                        stock_number                : origData.stock_number,
                        bt_id                       : origData.bt_id,
                        license                     : origData.license,
                        license_state               : origData.license_state,
                        sim                         : origData.sim,
                        sirius_esn                  : origData.sirius_esn,
                        sirius_esn_expiration_date  : parseDateForRequest(origData.sirius_esn_expiration_date),
                        lein_holder                 : origData.lein_holder,
                        registration                : parseDateForRequest(origData.registration),
                        registration_expiration     : parseDateForRequest(origData.registration_expiration),
                        emissions_expiration        : parseDateForRequest(origData.emissions_expiration),
                        toll_tag_number             : origData.toll_tag_number || null,
                        toll_tag_verified           : origData.toll_tag_verified,
                        firmware_version            : origData.firmware_version,
                        mileage                     : origData.mileage,
                        mileage_in_km               : origData.mileage_in_km,
                        has_gps                     : origData.has_gps,
                        color                       : origData.color
                    }
                });
            };

            this.saveVehicleStatus = function(args, data) {
                var origData = $.extend(true, {}, data);
                var unavailableDate = origData.unavailable_date ? parseDateForRequest(origData.unavailable_date) : null;

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    id: origData.id,
                    location_id: origData.location_id,
                    car: {
                        available_date      : parseDateForRequest(origData.available_date),
                        unavailable_date    : unavailableDate,
                        physical_location   : origData.physical_location,
                        location_id         : origData.new_location_id
                    }
                });

                if (origData.hasOwnProperty('location_attributes')) {
                    data.location_id = origData.location_attributes.data.id;
                }
            };
        },
        responseTransforms: new function() {
            this.loadVehicleDetails = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    available_date              : parseDateForResponse(origData.available_date),
                    bt_id                       : origData.bt_id,
                    car_board_version           : origData.car_board_version,
                    connected                   : origData.connected,
                    current_state               : origData.current_state,
                    disposed_at                 : parseDateForResponse(origData.disposed_at),
                    emissions_expiration        : parseDateForResponse(origData.emissions_expiration),
                    event_type                  : origData.event_type,
                    firmware_version            : origData.firmware_version,
                    fuel                        : origData.fuel,
                    fuel_capacity               : origData.fuel_capacity,
                    has_gps                     : origData.has_gps,
                    id                          : origData.id,
                    last_connected_car_scan     : origData.last_connected_car_scan,
                    last_off_lot                : origData.last_off_lot,
                    latitude                    : origData.latitude,
                    lein_holder                 : origData.lein_holder,
                    license                     : origData.license,
                    license_state               : origData.license_state,
                    location_id                 : origData.location_id,
                    longitude                   : origData.longitude,
                    make                        : origData.make,
                    mileage                     : isNaN(parseFloat(origData.mileage)) ? 0 : parseFloat(origData.mileage).toFixed(),
                    mileage_in_km               : origData.mileage_in_km,
                    model_name                  : origData.model_name
                                                    .replace(/TDI$/, ' TDI')
                                                    .replace(/^A8L$/, 'A8 L')
                                                    .replace(/^FordTransitWagonT350$/, 'Ford Transit Wagon T350'),
                    model_year                  : origData.model_year,
                    off_lot                     : origData.off_lot,
                    physical_location           : origData.physical_location,
                    position_viewable           : origData.position_viewable,
                    registration                : parseDateForResponse(origData.registration),
                    registration_expiration     : parseDateForResponse(origData.registration_expiration),
                    scan_source                 : origData.scan_source,
                    scanned_at                  : origData.scanned_at,
                    sim                         : origData.sim,
                    sirius_esn                  : origData.sirius_esn,
                    sirius_esn_expiration_date  : parseDateForResponse(origData.sirius_esn_expiration_date),
                    stock_number                : origData.stock_number,
                    toll_tag_number             : origData.toll_tag_number,
                    toll_tag_verified           : origData.toll_tag_verified,
                    trim_id                     : origData.trim_id,
                    unavailable_date            : parseDateForResponse(origData.unavailable_date),
                    vin                         : origData.vin,
                    color                       : origData.color,
                });

                if (origData.hasOwnProperty('location_attributes')) {
                    data.location_attributes = {
                        data: origData.location_attributes
                    };
                }

                if (data.connected) {
                    data.fuel_level = $rootScope.calculateFuelLevel(data.fuel, data.fuel_capacity);
                }
            };

            this.loadVehicleStates = function(args, data) {
                $.each(data, function(k,v) {
                    if (v.state === 'rent') {
                        data.splice(k,1);
                        return false;
                    }
                });
            };
        },
        customActions: {
            create: {
                method: 'POST',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            loadVehicleDetails: {
                method: 'GET',
                endpoint: '/locations/:location_id/cars/:id',
                ignoreDefaultRootNodeResponse: true,
                associationMapper   : {
                    mapIt: function (returnData) {
                        var lastCarScan = returnData.data.last_car_scan;

                        // No car_scans for the vehicle in question means lastCarScan === null,
                        // so guard appropriately.
                        //
                        return angular.extend(returnData.data || { }, {
                            event_type  : lastCarScan && lastCarScan.event_type ? lastCarScan.event_type            : undefined,
                            fuel        : lastCarScan && lastCarScan.fuel       ? parseFloat(lastCarScan.fuel)      : 0,
                            latitude    : lastCarScan && lastCarScan.latitude   ? parseFloat(lastCarScan.latitude)  : 0,
                            longitude   : lastCarScan && lastCarScan.longitude  ? parseFloat(lastCarScan.longitude) : 0,
                            scanned_at  : lastCarScan && lastCarScan.created_at ? lastCarScan.created_at            : undefined,
                            scan_source : lastCarScan && lastCarScan.device     ? lastCarScan.device                : undefined
                        });
                    }
                }
            },
            loadQrCode: {
                method: 'GET',
                endpoint: '/locations/:location_id/cars/:id/qr_code',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            saveVehicleDetails: {
                disabled: false,
                method: 'PUT',
                endpoint: '/locations/:location_id/cars/:id',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            saveVehicleStatus: {
                disabled: false,
                method: 'PUT',
                endpoint: '/locations/:location_id/cars/:id/availability',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            loadVehicleStates: {
                disabled: false,
                method: 'GET',
                endpoint: '/locations/:location_id/cars/:id/states',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            updateVehicleState: {
                disabled: false,
                method: 'PUT',
                endpoint: '/locations/:location_id/cars/:id/:new_state',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            scanCCD: {
                method: 'GET',
                endpoint: '/locations/:location_id/cars/:id/car_scans',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true,
                params: {
                    sort_by: 'created_at',
                    sort_direction: 'desc',
                    last_ccd: true
                }
            },
            collisions: {
                method: 'GET',
                endpoint: '/admin/vehicles/:id/collisions',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true,
                headers: { 'Api-Version': '4', 'Accept': 'application/json' }
            },
            serviceWarnings: {
                method: 'GET',
                endpoint: '/admin/vehicles/:id/service_warnings',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true,
                headers: { 'Api-Version': '4', 'Accept': 'application/json' }
            },
            telematicsLastEvent: {
                method: 'GET',
                endpoint: '/admin/vehicles/:id/telemetry',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true,
                headers: { 'Api-Version': '4', 'Accept': 'application/json' }
            }
        }
    });

    jQuery.extend(model.prototype,{
        searchDisplay: function() {
            var _license = (this.data && isObject(this.data) && this.data.hasOwnProperty('license') && this.data.license)  ? this.data.license : '';
            var _vin = (this.data && isObject(this.data) && this.data.hasOwnProperty('vin') && this.data.vin)  ? this.data.vin : '';
            return (_license && _vin) ? ( _license + " (" + _vin + ")") : _license;
        }
    });

    model.loadVehicleIssues = function(args) {
        DealerwareIssueCollection.index({
            params: args.params,
            successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
            errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
        });
    };

    model.loadVehicleScans = function(args) {
        DealerwareScanCollection.getScans({
            params: args.params,
            successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
            errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
        });
    }

    model.loadVehicleContracts = function(args) {
        DealerwareVehicleContractCollection.forVehicle({
            params: args.params,
            successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
            errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
        });
    };

    model.loadTollHistory = function(args) {
        DealerwareTollCollection.index({
            params: args.params,
            successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
            errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
        });
    };

    return model;
});
